import { Pipe, PipeTransform } from '@angular/core';
import { Patient } from '../services/model';
import dayjs from 'dayjs';

@Pipe({
  name: 'ageString',
  standalone: true,
})
export class AgeStringPipe implements PipeTransform {
  transform(patient: Patient | undefined): string {
    if (patient?.birthDateIso) {
      return dayjs(patient?.birthDateIso).format('DD.MM.YYYY');
    }
    return '';
  }

  transformAge(patient: Patient | undefined): string {
    if (patient) {
      const now = new Date();
      if (patient.birthDateIso) {
        const ageYears = this.calculateAge(patient.birthDateIso);
        const suffix = ageYears === 1 ? ' Jahr' : ' Jahre';
        console.log('ageyears' + ageYears);

        return ageYears + suffix;
      } else {
        const date = new Date(patient.birthYear!, patient.birthMonth! - 1);
        const diff = Math.abs(now.getTime() - date.getTime());
        const ageDays = Math.floor(diff / (1000 * 60 * 60 * 24));
        const ageYears = Math.floor(ageDays / 365);
        const ageDaysRest = ageDays % 365;
        const prefix = ageDaysRest < 30 ? 'ca. ' : '';
        const suffix = ageYears === 1 ? ' Jahr' : ' Jahre';
        return prefix + ageYears + suffix;
      }
    } else {
      return '';
    }
  }

  calculateAge(_birthDate: string) {
    const today = new Date();
    const birthDate = new Date(_birthDate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}
